import { useMutation } from '@tanstack/react-query';
import { passwordResetApi } from '../api/passwordReset.api';
import type { PasswordResetConfirmRequest } from '../types/passwordReset.types';

/**
 * Mutation: POST /api/eraf/auth/password-reset/confirm
 * mutationKey: ['passwordReset', 'confirm']
 */
export function usePasswordResetConfirm() {
  return useMutation({
    mutationKey: ['passwordReset', 'confirm'],
    mutationFn: (req: PasswordResetConfirmRequest) =>
      passwordResetApi.confirm(req),
  });
}
